// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__21CEn","dragIcon":"Choice_dragIcon__23N-_","left":"Choice_left__VwNjz","input":"Choice_input__2SnaT"};